"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resendVerifyEmail = exports.resetPassword = void 0;
const fp = require("fp-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const actionTypes = require("../../actionTypes/auth/resetPassword");
const actions = require("../../actions/auth/resetPassword");
const loginActions = require("../../actions/auth/login");
const validate = (action) => {
    if (action.payload.password !== action.payload.confirmPassword) {
        return fp.either.left('PASSWORDS_DO_NOT_MATCH');
    }
    return fp.either.right(action);
};
function resetPassword(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.RESET_PASSWORD_REQUEST), (0, operators_1.mergeMap)((action) => validate(action).fold((e) => (0, rxjs_1.of)(actions.resetPasswordValidation(e)), () => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: {
            mode: action.payload.mode,
            password: action.payload.password,
            code: action.payload.code,
            email: action.payload.email,
            language: action.payload.language
        },
        url: `${baseUrl}api/auth/reset-password`
    }).pipe((0, operators_1.mergeMap)(() => {
        const successActions = [];
        successActions.push(actions.resetPasswordSuccessAction());
        successActions.push(loginActions.loginRequestAction(action.payload.email, action.payload.password));
        return (0, rxjs_1.of)(...successActions);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(actions.resetPasswordFailureAction((0, errorHandling_1.parseAjaxErrorResponse)(e))))))));
}
exports.resetPassword = resetPassword;
function resendVerifyEmail(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.RESEND_VERIFY_EMAIL_REQUEST), (0, operators_1.mergeMap)((payload) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/auth/resend-verification`,
        body: { email: payload.payload }
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(actions.resendVerifyEmailSuccess())), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(actions.resendVerifyEmailFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.resendVerifyEmail = resendVerifyEmail;
//# sourceMappingURL=resetPassword.js.map